import RenderIf from 'components/RenderIf/RenderIf';
import { useGetTimelineComments } from 'views/Tasks/Timeline/hooks/useGetTimelineComments';
import { useOrganizationUsersContext } from 'contexts/OrganizationUsersContext';
import CommentComposer from './CommentComposer/CommentComposer';
import CommentThread from './CommentThread/CommentThread';

export interface TimelineSlideoutCommentsProps {
    orgId: string;
    dealId: number;
    timelineId: number;
    enabled: boolean;
}

const TimelineSlideoutComments = ({
    orgId, dealId, timelineId, enabled,
}: TimelineSlideoutCommentsProps) => {
    const { currentUserCorrelationId } = useOrganizationUsersContext();
    const { data: comments, isLoading } = useGetTimelineComments({
        orgId, dealId, timelineId, enabled,
    });

    const threads = comments ?? [];

    return (
        <div className="p-3">
            <div className="mb-3">
                <CommentComposer orgId={orgId} dealId={dealId} timelineId={timelineId} />
            </div>
            <RenderIf isLoading={isLoading} isTrue>
                {threads.length === 0 ? (
                    <div className="text-muted">No comments yet.</div>
                ) : (
                    threads.map(thread => (
                        <CommentThread
                            key={thread.id}
                            thread={thread}
                            depth={0}
                            orgId={orgId}
                            dealId={dealId}
                            timelineId={timelineId}
                            currentUserCorrelationId={currentUserCorrelationId}
                        />
                    ))
                )}
            </RenderIf>
        </div>
    );
};

export default TimelineSlideoutComments;
